// What to tell a person when a call fails: the API's own message ({"error": {"message": ...}}), else the client's.
export const errorText = (ex) => (ex && ex.response && ex.response.data && ex.response.data.error && ex.response.data.error.message)
  || (ex && ex.message)
  || 'The request failed.';
